import { MetricsType } from '@/services/api/resources/analytics-builder/constants';
import { t } from '@/ui/i18n/i18n';

export const useMetrics = () => {
  const getMetricsWithLabels = (): Array<{value: MetricsType; label: string}> => [
    { value: 'submitted-forms', label: t('analytics.metric.submitted-forms') },
    { value: 'form-score', label: t('analytics.metric.form-score') },
    { value: 'form-items', label: t('analytics.metric.form-items') },
    { value: 'negative-responses', label: t('analytics.metric.negative-responses') },
    { value: 'form-item-score', label: t('analytics.metric.form-item-score') },
    { value: 'schedule-forms', label: t('analytics.metric.schedule-forms') },
    { value: 'actions', label: t('analytics.metric.actions') },
  ];

  const findMetricLabel = (metric: MetricsType): string => {
    const metrics = getMetricsWithLabels();

    return metrics.find(m => m.value === metric)?.label ?? '';
  };

  return {
    getMetricsWithLabels,
    findMetricLabel,
  };
};
